module.exports = __webpack_public_path__ + "static/live-map.48495c7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/live-map.svg
// module id = 196
// module chunks = 35783957827783 154861247209503